import React from 'react'

const siemReap = {
    id: 'siem-reap',
    type: 'post',
    countryId: 'seAsia',
    title: 'Angkor Wat and More: 3 Days in Siem Reap',
    longDate: 'Feb 2, 2019',
    month: 'Feb',
    date: '2',
    // This one is using the raw file since for some reason the website version doesn't seem to work. Not sure why, but if there's a problem in the future, this is probably why.
    coverImage: 'https://raw.githubusercontent.com/plivesey/world-of-wander-images/master/posts/seAsia/siem-reap/AW4.jpg',
    coverImagePosition: 'top',
    content: [
        {
            subheader: 'The Airport That Tourism Built'
        },
        {
            text: (
                <div>The Siem Reap airport is not the smallest airport I've been to – that distinction goes to Kalispell in Montana – but it's the most hotel lobby-like airport experience I've ever had. The place is brand new. As your plane lands on the tiny tarmac and you walk in to collect your bags, you pass by sculpted gardens, clean white stucco walls, and not a single orange cone or beeping truck. Inside it's airy, clean, modern, and only inhabited at any given time by the passengers of one flight coming in and 1-2 flights departing (almost entirely foreigners). The airport did exist before the huge boom in tourism that Siem Reap has seen in the last 10 years, but they just redid the place last year. </div>
            )
        },
        {
            text: (
                <div>We were visiting Siem Reap for three days with our family: my mom and little sister, and Peter's parents, who had all flown into Saigon a few days earlier. We all existed the airport that first afternoon feeling the most blissful an airport has ever made anyone feel, ready for our first ride out to the temples that evening.</div>
            )
        },
        {
            subheader: 'Sunset at Angkor Wat'
        },
        {
            text: (
                <div>After a brief stop at our hotel to drop off bags and take advantage of their 2-for-1 beers, we met our tuk-tuk driver, <a href="https://www.facebook.com/meas.globalteer">Meas</a>. My chiropractor in Saigon had recommended him, and Meas and I had been texting through FB Messenger (nearly all businesses around Vietnam run on it, too). He and his brother each took 3 of us in a tuk-tuk and we drove off to buy tickets. To enter the temple at Angkor Wat, you buy a ticket for Angkor Archaeological Park, which covers over 400 square kilometers and many, many more temples. The options for passes are 1 day at $37 or 3 days at $62 – definitely higher than other prices in Southeast Asia, but very much worth it, and it funds restoration as well as facilities for the 2.5 million annual visitors.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/tuktuk.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/tuktuk2.jpg'
        },
        {
            text: (
                <div>When we arrived at the parking lot, there was a barrier blocking cars, tuk-tuks, and even bicycles from getting closer. As we approached the main (western) gate, it became clear why: Angkor Wat is surrounded by a moat, and with the original stone bridge under restoration, the only way in was over a temporary floating bridge made of plastic cubes tied together. The walk across the moat and up to the gate was quite long, and once we got through the gate, we saw the main temple off in the distance with a massive courtyard and very long walkway to get there. When it was built originally, the courtyard housed the king in a wooden palace, but now it's just a vast grassy expanse.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/AW5.jpg'
        },
        {
            text: (
                <div>Inside, the golden light streaming through stone hallways was beautiful. With the exception of Peter (whose preferred method of exploring a place is to walk quickly through it and maybe return to an area he found interesting to look closer) we all wandered very slowly, staring at the carvings. I didn't realize before going that the Khmer people were mostly Hindu at the time, the 1100s. The temple is dedicated to Vishnu, Brahma, and Shiva.</div>
            )
        },
        {
            text: (
                <div>After the Cambodian people abandoned it to built a new capital city, Buddhist monks cared for the temple (and filled it with Buddha statues) up until its "discovery" by the French in the 1800s. The temple had fallen down in many places due to time and weather, but Angkor Wat was sadly further damaged during the Cambodia Civil War under the Khmer Rouge in the 1970s.</div>
            )
        },
        {
            text: (
                <div>My favorite tidbit about Angkor Wat was learning why the stairs up to the central sanctuary are so steep: the king used to arrive via elephant through a back entrance and sit at the top, and his people had to climb up hunched over and practically bowing up the stairs to pay their respects. The moment of the sun actually setting wasn't hugely impressive – the sky had a reddish, dusty haze – but the golden light throughout the hour leading up to it was absolutely beautiful.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/AW1.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/AW2.jpg','https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/AW3.jpg']
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/peter.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/window.jpg',
            detailText: 'Our impromptu photo session in this sunlit window.'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/window2.jpg','https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/window3.jpg']
        },
        {
            subheader: 'The Circus'
        },
        {
            text: (
                <div>When researching what to do in Siem Reap beyond temples, Peter found an article in the <a href="https://www.nytimes.com/2015/07/26/travel/what-to-do-in-36-hours-in-siem-reap-cambodia.html">New York Times</a> which we couldn't decide was ironic or not. In addition to suggesting a mini-golf course with replicas of the temples, it recommended a night at Phare Circus – so Peter signed us up. I am very skeptical of both circuses and theater productions (this was a mix) and probably wouldn't have booked it if we didn't have family coming, but it turned out to be fun and memorable.</div>
            )
        },
        {
            text: (
                <div>The plot centered around the evils of coveting wealth, symbolized by rice. The performers had a variety of acts, from tumbling to a crazy yo-yo routine to acrobatic feats of strength. They were all students or teachers at the circus school, which provides free education for plus along with training in the arts, funded by proceeds from the shows.</div>
            )
        },
        {
            text: (
                <div>But the coolest part was at the end: we witnessed a proposal! It looked like the performers were coming out for an encore dance, but then they pulled down two people from the first row and formed a circle around them, and the man dropped down onto one knee. The crowd went wild.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/circus.JPG'
        },
        {
            subheader: 'Sunrise and Bikes'
        },
        {
            text: (
                <div>I've never heard so many grumbles out of my mother about an early wake up call as when I told her we were getting picked up at 4:50 for our Angkor Wat sunrise tour through <a href="https://www.grasshopperadventures.com/en/day-tours/angkor-sunrise-discovery.html">Grasshopper Adventures</a>. Considering I spent four years of high school grumbling at her for making sure I got to school on time, it was payback. Not only was this tour at sunrise, it also involved miles of biking. While everyone ended up enjoying it, it was definitely <a href="https://www.rei.com/blog/climb/fun-scale">type two fun</a> and Peter joked at one point (biking up a hill in the sun), "Whose idea of a vacation was this?"</div>
            )
        },
        {
            text: (
                <div>4:50 did seem a bit extreme, since our hotel was only 20 minutes from Angkor Wat and the sun rose at 6:45. But it was pretty magical to watch the sky move slowly from navy to light pink and the water lily flowers slowly open.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/AWsunrise.jpg'
        },
        {
            text: (
                <div>Our guide Sambo showed us pictures from the equinox, where hordes crowd the courtyards to see the sun rise perfectly suspended over the central sanctuary. Even on the day we were there, hundreds of tourists streamed in. Sambo positioned us on the moat bank opposite the main gate, where we could have a view across the water without the crowds, and brought <a href="https://www.tripadvisor.com/Restaurant_Review-g297390-d1133338-Reviews-Blue_Pumpkin-Siem_Reap_Siem_Reap_Province.html">croissants</a> and coffee – he knew what he was doing!</div>
            )
        },
        {
            text: (
                <div>When the sun was fully up, we explored Angkor Wat again, this time with history and context from Sambo. After we exited out the east gate, it was time for second breakfast – a full spread of American food with more coffee and tea.</div>
            )
        },
        {
            text: (
                <div>Properly stuffed and sure that we wouldn't be hungry for lunch later, we hopped on bikes to head over to Angkor Thom. (We were wrong about the amount of food. An hour later, they gave us a massive fruit platter, and we were still very hungry by the time it got to lunch.)</div>
            )
        },
        {
            text: (
                <div>I had pictured biking leisurely along paved paths in the temples. Wrong. This was an adventure tour. We started off on a tiny track through the jungle behind Angkor Wat, dodging tree branches and pedaling furiously through sand pits. After winding through the trees, we emerged onto a rocky path following the moat and headed north to Angkor Thom, where our guide told us we'd be biking along the top of the old walls. Peter's mom Hilary nearly refused because of the height, but once we were up there, it was actually a wide (sandy, rocky) path that gently sloped down on one side rather than a steep drop.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/biking.jpg'
        },
        {
            text: (
                <div>By noon, we'd made it to Boyon temple. We followed Sambo around as he showed us details of the Hindu and Buddhist carvings, darting into the shade whenever we could. When we learned it was another 7 kilometers to the next spot, Hilary tapped out and got on the van with my mom. The rest of us saddled up and gave it another go.</div>
            )
        },
        {
            text: (
                <div>Actually, it was really cool to explore the park by bike – we were completely alone and got to see things that were literally off the beaten path. But at the entrance to Ta Prohm (the Tomb Raider tree temple), Sambo let us sit down while he explained the history, and I got caught taking a quick nap behind my sunglasses.</div>
            )
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/AT2.jpg','https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/AT3.jpg'],
            detailText: 'Merilee at Boyon temple.'
        },
        // {
        //     images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/face1.jpg','https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/face1.jpg'],
        //     detailText: 'Left, the western gate to Angkor Thom, once a city of a million people. Right, Boyon temple has over 40 towers with carved faces.'
        // },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/taprohm.jpg',
            detailText: 'Ta Prohm, with trees growing up straight through the ruins, is known as the Tomb Raider temple – it was used as a location in the film.'
        },
        {
            subheader: 'Wine Time'
        },
        {
            text: (
                <div>After lunch and a long shower and nap, we roused ourselves for the next activity: tasting sraa, Cambodian rice wine. We made a reservation at <a href="https://www.sombai.com/en/where-to-find-sombai/for-a-free-tasting">Sombai</a>, where they showed us all the infused bottles fermenting upstairs and gave us tiny samples of a dozen kinds of sraa from spicy chili infusions to coffee and anise to sickenly sweet banana and coconut. We followed it up with sraa-infused jams; we loved the tomato chili, but couldn't justify buying a jar with only a few weeks left in the apartment and how little we've actually been cooking. Instead we took home a small bottle of the green mango chili sraa for rooftop sipping in Saigon.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/drinking.jpg'
        },
        {
            text: (
                <div>For dinner, we took Sambo's recommendation for <a href="https://www.tripadvisor.com/Restaurant_Review-g297390-d4315982-Reviews-Khmer_Grill_Restaurant-Siem_Reap_Siem_Reap_Province.html">Khmer Grill</a> and were not disappointed. Four of us split a bottle each red and white wine, which wasn't very good – good wine is one thing I do really, really miss in Asia.</div>
            )
        },
        {
            subheader: 'Banteay Srei'
        },
        {
            text: (
                <div>We took our time the next morning getting ready and eating breakfast, and debated just having a relaxing day of massages, the pool, and lunch. But since we had the three day park pass, we decided not to waste it and hired Meas again to drive us an hour and a half out in the countryside to the temple at Banteay Srei. It was so worth it! The carvings there were the deepest and most intricate we'd seen. It's nicknamed the women's temple, and one theory for why is that surely only women could make sure beautiful carvings. There weren't tons of people either, so we were able to wander and spend a long time exploring.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/BR1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/siem-reap/BR2.jpg'
        },
        {
            text: (
                <div>On the way back, we stopped at <a href="https://www.tripadvisor.com/Restaurant_Review-g297390-d7805494-Reviews-Bayon_Pastry_School_Coffee_Shop-Siem_Reap_Siem_Reap_Province.html">Bayon Pastry School and Coffee Shop</a>, a vocational school that provides training and housing to underprivileged Cambodian women. The quiches and pastries were delicious – worth the trip a ways from the city center.</div>
            )
        },
        {
            text: (
                <div>All in all, this was an amazing trip and I'm glad I got to share it with family members. Just before we left, we grabbed dinner at <a href="https://www.tripadvisor.com/Restaurant_Review-g297390-d14015193-Reviews-Rina_s_Khmer_Kitchen-Siem_Reap_Siem_Reap_Province.html">Rina's Khmer Kitchen</a> and talked to the British owner about how things had changed since he moved there 15 years ago. The street we were sitting on was paved, and packed with tuk-tuks and motorbikes. He answered that ten years ago, farmers walked cows down that street to get to the fields just a few hundred meters away. Now, it's two kilometers before you might see the next cow. Who knows how much it will change in another ten years?</div>
            )
        }
]
}


export default siemReap


// WEBPACK FOOTER //
// ./src/Posts/Content/siemReap.js